module.exports = __webpack_public_path__ + "media/images/athletes/2283-c9cd3d8ea31f30588af231189b088f96.png";